// const { NODE_ENV } = process.env
export const state = () => ({
  loading: false,
  authenticated: false,
  user: false,
  url: process.env.GALAXY_BASE_URL
})
export const getters = {
  loading(state) {
    return state.loading
  },
  authenticated(state) {
    return Boolean(state.user)
  },
  url(state) {
    return state.url
  },
  user(state) {
    return state.user
  }
}
export const mutations = {
  setLoading(state, { data }) {
    state.loading = data
  },
  setUser(state, { data }) {
    state.user = data
  }
}
export const actions = {
  async getUser({ commit }, { uid }) {
    commit('setLoading', { data: true })
    return await this.$axios
      .get(`/api/galaxy/profile/me/${uid}`, {
        withCredentials: true
      })
      .then((res) => {
        commit('setUser', { data: res.data })
        commit('setLoading', { data: false })
        return res
      })
      .catch((err) => {
        console.error(err)
        commit('setLoading', { data: false })
        commit('setUser', { data: false })
        return false
      })
  }
}
